import { Link } from "react-router-dom";
import { ArrowRight, RefreshCw } from "lucide-react";
import { Reveal } from "./Reveal";

export const TradeBanner = () => (
  <section data-testid="home-trade-banner" className="mx-auto max-w-[1440px] px-5 pb-24 sm:px-8 sm:pb-36">
    <Reveal>
      <div className="flex flex-col gap-6 rounded-[32px] border border-white/10 bg-white/[0.04] p-6 sm:flex-row sm:items-center sm:justify-between sm:p-10">
        <div className="flex items-start gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-white text-black"><RefreshCw className="h-5 w-5" /></span>
          <div>
            <p className="font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">Tem um aparelho seminovo? Use na troca.</p>
            <p className="mt-2 max-w-xl text-sm text-zinc-300">Responda 6 perguntas, anexe os prints e veja na hora uma avaliação estimada do seu iPhone, iPad, Mac, Apple Watch ou AirPods.</p>
          </div>
        </div>
        <Link data-testid="home-trade-cta" to="/troca" className="group inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-white px-6 py-3.5 text-sm font-bold text-black transition-transform duration-300 hover:scale-[1.03] active:scale-95">
          Avaliar meu aparelho <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </Reveal>
  </section>
);
